import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { supabase } from "lib/supabaseClient";
import { Toaster } from "react-hot-toast";

import AdminLayout from "layouts/admin";
import SignIn from "views/auth/SignIn";

const App = () => {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    // بدون تأخير - سرعة أفضل
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      setLoading(false);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="flex h-screen w-full flex-col items-center justify-center bg-white">
        <div className="relative flex items-center justify-center">
          <div className="h-12 w-12 animate-spin rounded-full border border-[#0055FF] border-t-transparent opacity-60"></div>
          <span className="absolute text-[8px] tracking-widest text-[#0055FF]">CORE</span>
        </div>
        <p className="mt-5 text-[9px] tracking-[0.5em] text-gray-400 uppercase">Loading</p>
      </div>
    );
  }

  return (
    <>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#ffffff",
            color: "#111827",
            border: "1px solid #e5e7eb",
            borderRadius: "10px",
            fontSize: "12px",
            fontWeight: "400",
            boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
          },
        }}
      />
      <Routes>
        <Route path="/" element={!session ? <SignIn /> : <Navigate to="/admin/default" replace />} />
        <Route
          path="admin/*"
          element={
            session ? (
              <div className="animate-fade-in">
                <AdminLayout />
              </div>
            ) : (
              <Navigate to="/" state={{ from: location }} replace />
            )
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
};

export default App;